import { Tag } from "features/shared/types/tag";
import { TagAction } from "features/tagEdit/types/actions";
import firebase from "firebase/app";
import "firebase/firestore";

import { AppThunk } from "services/redux/rootReducer";

const getAllTags = (): AppThunk<() => void> => (dispatch) => {
    const unsubscribe = firebase
        .firestore()
        .collection("tags")
        .onSnapshot((querySnapshot) => {
            const tags: Tag[] = [];
            querySnapshot.forEach((doc: firebase.firestore.DocumentData) => {
                tags.push(doc.data());
            });
            dispatch({
                type: TagAction.SET_TAGS,
                tags,
            });
        });

    return unsubscribe;
};

export default getAllTags;
